import { useQuery } from "@tanstack/react-query";

import useApiHelper from "../hooks/useApiHelper";
import { IPartSyncError } from "../models/PartSyncError";

/**
 * Marketplace failures recorded against a part - what Shopify/eBay actually said, raw body and all.
 * The durable copy of what used to exist only as a sampled Sentry event.
 */
export default function usePartSyncErrors(partId?: string, includeResolved = false) {
  const { get } = useApiHelper();

  const syncErrors = useQuery<IPartSyncError[]>({
    queryKey: ["partSyncErrors", partId, includeResolved],
    queryFn: () =>
      get<IPartSyncError[]>(
        `/part/${partId}/sync-errors?includeResolved=${includeResolved}`
      ).then((res: any) => res.data ?? []),
    enabled: !!partId,
  });

  return { syncErrors };
}
